import Marquee from "react-fast-marquee";

const ITEMS = ["Periods", "Emotions", "Curiosities", "PCOS", "Menopause", "Discomfort"];

export default function EditorialMarquee() {
    return (
        <div data-testid="editorial-marquee" className="border-y hairline py-6 overflow-hidden">
            <Marquee speed={28} gradient={false} pauseOnHover>
                {ITEMS.map((item, index) => (
                    <span key={item} className="flex items-center">
                        <span className="font-serif-display italic font-light text-3xl md:text-5xl text-[#F7F3FA] px-8 whitespace-nowrap">
                            {item}
                        </span>
                        {index !== ITEMS.length &&
                            <span className="font-serif-display text-3xl md:text-5xl text-[#F3698F]">—</span>
                        }
                    </span>
                ))}
            </Marquee>
        </div>
    );
}